import { render } from "./TableHead.vue?vue&type=template&id=3917ed50"
import script from "./TableHead.vue?vue&type=script&lang=js"
export * from "./TableHead.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Tables/TableHead.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3917ed50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3917ed50', __exports__)) {
    api.reload('3917ed50', __exports__)
  }
  
  module.hot.accept("./TableHead.vue?vue&type=template&id=3917ed50", () => {
    api.rerender('3917ed50', render)
  })

}


export default __exports__